import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Popover from '@mui/material/Popover'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import Button from '@mui/material/Button'
;('use no memo')
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Grid from '@mui/material/Grid2'
import { Table } from '@tanstack/react-table'
import CaleoIconButton from 'Components/reusable/IconButtons/CaleoIconButton'
import TableChartIcon from '@mui/icons-material/TableChart'

/**
 * Table column visibility controls.
 *
 * @param table - Table instance.
 * @returns Column visibility controls.
 * @notExported
 */
const VisibilityControls = ({ table }: { table: Table<any> }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const mobileView = useMediaQuery(theme.breakpoints.down('md'))

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  return (
    <span>
      {mobileView ? (
        <CaleoIconButton
          testId="button-table-visibility-toggle-mobile"
          valid
          icon={<TableChartIcon />}
          tooltip={t('hideColumns')}
          clickAction={(e: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(e.currentTarget)
          }}
        />
      ) : (
        <Button
          data-testid="button-table-visibility-toggle"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            setAnchorEl(e.currentTarget)
          }}
          size="small"
          variant="contained"
          color="primary"
        >
          {t('hideColumns')}
        </Button>
      )}
      <Popover
        open={!!anchorEl}
        onClose={() => {
          setAnchorEl(null)
        }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Grid container direction="column" px={1}>
          <Grid>
            <FormControlLabel
              control={
                <Checkbox
                  data-testid="checkbox-table-visibility-all"
                  checked={table.getIsAllColumnsVisible()}
                  onChange={() => {
                    table.toggleAllColumnsVisible()
                  }}
                  color="secondary"
                />
              }
              label={t('toggleAll')}
            />
          </Grid>
          {table.getAllLeafColumns().map(column => {
            if (column.id !== 'controls' && typeof column.columnDef.header === 'string') {
              return (
                <FormControlLabel
                  key={column.id}
                  control={
                    <Checkbox
                      key={column.id}
                      data-testid={`checkbox-table-visibility-${column.id}`}
                      checked={column.getIsVisible()}
                      onChange={() => {
                        column.toggleVisibility()
                      }}
                      color="secondary"
                    />
                  }
                  label={<>{column.columnDef.header ?? ''}</>}
                />
              )
            }
          })}
        </Grid>
      </Popover>
    </span>
  )
}

export default VisibilityControls
